import { Injectable } from "@angular/core";
import { HttpWrapperService } from "./http.wrapper.service";
import { SessionManagerService } from "./SessionManager/session-manager.service";
import { LoggerService } from "../modules/logger/logger.service";
import { observableToPromise } from "../admin/events-screen/utils/observableToPromise";
import { ResponseContentType } from "@angular/http";
import { SaveActionResult } from "../admin/events-screen/event-page-models/save-action-result";

@Injectable()
export class FilesService {
  constructor(
    private http: HttpWrapperService,
    private sessionManager: SessionManagerService,
    private logger: LoggerService
  ) {}

  public async downloadGeneralFile({
    response,
    fileName,
  }: {
    response: Response | any;
    fileName: string;
  }) {
    try {
      const blob = await response.blob();

      const link = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      document.body.appendChild(a);
      a.setAttribute("style", "display: none");
      a.href = link;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(link);
      a.remove();
    } catch (error) {}
  }
  public async downloadFileFromExternalUrl({
    url,
    fileName,
  }: {
    url: string;
    fileName: string;
  }): Promise<SaveActionResult> {
    try {
      const response = await observableToPromise(
        this.http.getExternalUrl(url, {
          responseType: ResponseContentType.Blob,
        })
      );

      const blob = await response.blob();
      const link = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.setAttribute("style", "display: none");
      a.href = link;
      a.download = fileName || "receipt.pdf"; // Set the desired file name
      a.click();
      window.URL.revokeObjectURL(link);
      a.remove();
      return {
        success: true,
        data: {
          message: "File downloaded successfully",
        },
      };
    } catch (error) {
      this.logger.error("Error downloading file:", error);
      return {
        success: false,
        error,
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/files.service.ts